import { render, staticRenderFns } from "./FormDesc.vue?vue&type=template&id=baaeb888&"
import script from "./FormDesc.vue?vue&type=script&lang=js&"
export * from "./FormDesc.vue?vue&type=script&lang=js&"
import style0 from "./FormDesc.vue?vue&type=style&index=0&id=baaeb888&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports